import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { combineLatest, of, catchError, map, take } from 'rxjs';
import { UserGroup } from '../pages/admins/user.service';
import { extractCognitoGroups } from '../utils/cognito-groups.util';

export const testingAccessGuard: CanActivateFn = () => {
  const oidc = inject(OidcSecurityService);
  const router = inject(Router);
  const denied = () => router.createUrlTree(['/forbidden']);
  return combineLatest([oidc.getUserData().pipe(take(1)), oidc.getAccessToken().pipe(take(1))]).pipe(
    map(([user, token]) => {
      const groups = extractCognitoGroups(user, token);
      return groups.some((group) => group === UserGroup.Admin || group === UserGroup.SuperAdmin) || denied();
    }),
    catchError(() => of(denied())),
  );
};
